/**
 * @packageDocumentation
 * @module f1/string
 */

export interface Search {
  /**
   * Returns true if searchString appears as a substring of the result of converting this object to a String, at one or more positions that are greater than or equal to position; otherwise, returns false.
   *
   * @public
   * @function f1.search
   * @param search the string to search for
   * @param from the index to start looking
   * @param s a string of a variable
   * @example
   *
   * ```ts
   * f1.search('a', 2, 'abca') === true
   * f1.search('a', 2, 'abcd') === false
   * ```
   */
  (search: string, from: number, s: string): boolean;
  (search: string, from: number): (s: string) => boolean;
}

/**
 * @see Search
 */
export default (search: string, from: number, s: string): boolean => {
  return s.includes(search, from);
};
